import { clsx } from "clsx";

export default function IconRoomPlan({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5V27H27V5H21V7H25V25H7V7H12.6979L18.4427 10.8333L19.5573 9.16667L13.3021 5H5Z"
        fill="currentColor"
      />
    </svg>
  );
}
